function useStyles() {
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
    },
    buttonContainer: {
      display: 'flex',
      justifyContent: 'flex-start',
    },
  }
}

export { useStyles }
